import {COLOR_RECIPE, COLOR_HIGHLIGHT} from '@/utils/constants'

const commonParams = {
  backgroundColor: COLOR_RECIPE,
  sortable: false,
  color: '#000000',
  isActive: true,
  disabledRow: true,
  isBreakLine: true,
  onEnableEditMode: () => false
}
export const columns = [
  {
    name: 'item',
    align: 'center',
    value: 'item',
    maxWidth: '210px',
    ...commonParams,
    backgroundColor: COLOR_HIGHLIGHT
  },
  {
    name: 'variety',
    align: 'center',
    value: 'variety',
    maxWidth: '150px',
    ...commonParams,
    backgroundColor: COLOR_HIGHLIGHT
  },
  {
    name: 'product_area',
    align: 'start',
    value: 'product_area',
    maxWidth: '150px',
    ...commonParams,
    backgroundColor: COLOR_HIGHLIGHT
  },
  {
    name: 'color',
    value: 'color',
    align: 'start',
    maxWidth: '85px',
    ...commonParams,
    backgroundColor: COLOR_HIGHLIGHT
  },
  {
    name: 'box_type_name',
    value: 'box_type_name',
    maxWidth: '94px',
    align: 'start',
    ...commonParams,
    backgroundColor: COLOR_HIGHLIGHT
  },

  {
    name: 'grade',
    align: 'start',
    maxWidth: '100px',
    value: 'grade',
    ...commonParams
  },
  {
    name: 'size',
    align: 'start',
    value: 'size',
    maxWidth: '72px',
    ...commonParams
  },
  {
    name: 'bloom',
    align: 'start',
    value: 'bloom',
    maxWidth: '85px',
    ...commonParams
  },

  {
    name: 'note',
    value: 'note',
    align: 'start',
    maxWidth: '150px',
    ...commonParams
  },
  {
    name: 'stem_bouquet',
    value: 'stem_bouquet',
    maxWidth: '65px',
    ...commonParams
  }
]
